import { render, staticRenderFns } from "./SellerMyBiddings.vue?vue&type=template&id=3f657f64&scoped=true&"
import script from "./SellerMyBiddings.vue?vue&type=script&lang=js&"
export * from "./SellerMyBiddings.vue?vue&type=script&lang=js&"
import style0 from "./SellerMyBiddings.vue?vue&type=style&index=0&id=3f657f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f657f64",
  null
  
)

export default component.exports